(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-compare-v3"] && !Shopify.designMode) return;
  try {
     
  document.addEventListener('DOMContentLoaded', () => {
    // 让 Vue 忽略以 yg- 开头的自定义标签（如 yg-image、yg-select 等），避免 Unknown custom element 报错
    if (window.Vue && Vue.config) {
      Vue.config.ignoredElements = Vue.config.ignoredElements || [];
      Vue.config.ignoredElements.push(/^yg-/);
    }

    class YGProductCompareV3 extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleWindowScroll = this.handleWindowScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleTopBarScroll = this.handleTopBarScroll.bind(this);
        this.handleFloatingTopBarScroll = this.handleFloatingTopBarScroll.bind(this);
        this.handleTopScroll = this.handleTopScroll.bind(this);
        this.handleDataScroll = this.handleDataScroll.bind(this);
      }
      get isFloatingTopBarEnabled() {
        return this.dataset.enableFloatingTopBar === 'true';
      }
      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;
        this._sectionsEl = {
          'product-form': this.querySelector('#yg-product-form') || this.querySelector('.yg-product-form'),
          'product-form-id': this.querySelector('#yg-product-form-id') || this.querySelector('.yg-product-form-id'),
          'product-data': this.querySelector('.yg-product-data'),
          'product-top-bar-shell': this.querySelector('.yg-product-top-bar-shell'),
          'product-top-bar-scroll': this.querySelector('.yg-product-compare-top-bar-container'),
          'floating-top-bar-shell': this.querySelector('.yg-product-floating-top-bar-shell'),
          'floating-top-bar-scroll': this.querySelector('.yg-product-floating-top-bar-container'),
          'product-top-scroll': this.querySelector('.yg-product-compare-top-container'),
          'product-data-scroll': this.querySelector('.yg-product-compare-data-container'),
        };

        return this._sectionsEl;
      }
      connectedCallback() {
        this.initVue();

        if (!this._eventsBound) {
          this.addEventListener('click', this.handleClick);
          window.addEventListener('resize', this.handleResize);
          this.sectionsEl['product-top-bar-scroll']?.addEventListener('scroll', this.handleTopBarScroll, { passive: true });
          this.sectionsEl['product-top-scroll']?.addEventListener('scroll', this.handleTopScroll, { passive: true });
          this.sectionsEl['product-data-scroll']?.addEventListener('scroll', this.handleDataScroll, { passive: true });
          if (this.isFloatingTopBarEnabled) {
            window.addEventListener('scroll', this.handleWindowScroll, { passive: true });
            this.sectionsEl['floating-top-bar-scroll']?.addEventListener('scroll', this.handleFloatingTopBarScroll, {
              passive: true,
            });
          }
          this._eventsBound = true;
        }

        this.handleResize();
        this.refreshDynamicHeights();
        if (this.isFloatingTopBarEnabled) {
          this.requestFloatingNavStateUpdate();
        }
      }
      disconnectedCallback() {
        if (!this._eventsBound) return;

        this.removeEventListener('click', this.handleClick);
        window.removeEventListener('resize', this.handleResize);
        this.sectionsEl['product-top-bar-scroll']?.removeEventListener('scroll', this.handleTopBarScroll);
        this.sectionsEl['product-top-scroll']?.removeEventListener('scroll', this.handleTopScroll);
        this.sectionsEl['product-data-scroll']?.removeEventListener('scroll', this.handleDataScroll);
        if (this.isFloatingTopBarEnabled) {
          window.removeEventListener('scroll', this.handleWindowScroll);
          this.sectionsEl['floating-top-bar-scroll']?.removeEventListener('scroll', this.handleFloatingTopBarScroll);
          this.closeTopBarDropdowns();
        }
        if (this._floatingNavFrame) {
          cancelAnimationFrame(this._floatingNavFrame);
          this._floatingNavFrame = null;
        }
        this._eventsBound = false;
      }
      initVue() {
        if (this._vue) return;

        if (!window.Vue || !window.ELEMENT) {
          console.warn('[yg-product-compare-v3] Vue or Element UI is not available.');
          return;
        }

        let _this = this;
        this._vue = new Vue({
          el: _this.querySelector('.yg-select-vue'),
          delimiters: ['${', '}'],
          data() {
            const productColumns = Math.min(4, Math.max(2, Number(_this.dataset.productColumns) || 3));
            let initialState = {
              options: [],
              values: [],
              productColumns,
              hideDuplicates: false,
              primaryRowCount: 0,
              groupRowCounts: {},
              isCondensedLayout: false,
              variantsCurrent: [
                { id: null, price: null, featured_image: null, available: null },
                { id: null, price: null, featured_image: null, available: null },
                { id: null, price: null, featured_image: null, available: null },
              ],
            };

            const textarea = _this.querySelector('#compare-data');
            if (textarea) {
              const raw = (textarea.value || textarea.textContent || '').trim();
              if (raw) {
                let parsed;
                try {
                  parsed = JSON.parse(raw);
                } catch (error) {
                  parsed = new Function('return ' + raw)();
                }
                if (parsed && Array.isArray(parsed.options)) {
                  initialState.options = parsed.options;
                }

                initialState.values = initialState.options.slice(0, productColumns).map((opt) => opt.value);
                initialState.variantsCurrent = [];
                initialState.values.forEach((handle) => {
                  const opt = initialState.options.find((option) => option && option.value === handle);
                  const variants = opt && opt.data && Array.isArray(opt.data.variants) ? opt.data.variants : [];
                  const firstVariant = variants[0] || null;
                  initialState.variantsCurrent.push({
                    id: firstVariant ? firstVariant.id : null,
                    price: firstVariant ? firstVariant.price : null,
                    featured_image:
                      firstVariant && firstVariant.featured_image ? firstVariant.featured_image.src : null,
                    available: firstVariant ? firstVariant.available : null,
                  });
                });

                while (initialState.variantsCurrent.length < productColumns) {
                  initialState.variantsCurrent.push({
                    id: null,
                    price: null,
                    featured_image: null,
                    available: null,
                  });
                }
              }
            }

            return initialState;
          },
          mounted() {
            this.primaryRowCount = _this.querySelectorAll('.yg-product-data-group > .row').length;

            const groupRowCounts = {};
            _this.querySelectorAll('.yg-product-dropdown-wrap').forEach((groupWrap) => {
              const groupIndex = Number(groupWrap.dataset.groupIndex);
              if (Number.isNaN(groupIndex)) return;
              groupRowCounts[groupIndex] = groupWrap.querySelectorAll('.row').length;
            });
            this.groupRowCounts = groupRowCounts;

            _this.syncResponsiveState();
            this.handleSpecificationVisibilityChange();
          },
          watch: {
            hideDuplicates() {
              this.handleSpecificationVisibilityChange();
            },
            values: {
              deep: true,
              handler() {
                this.handleSpecificationVisibilityChange();
              },
            },
            isCondensedLayout() {
              this.handleSpecificationVisibilityChange();
            },
          },
          methods: {
            formatMoney(cents) {
              const format = _this.getAttribute('data-currency-format');
              const valueNumber = Number(cents) || 0;
              const amount = valueNumber / 100;
              const amountStr = amount.toFixed(2);
              return format + amountStr;
            },
            handleProductChange(columnIndex, newColumnValue) {
              const variants = (this.variantsMap && this.variantsMap[newColumnValue]) || [];
              const nextVariant = variants[0] || null;
              const nextId = nextVariant ? nextVariant.id : null;

              this.$set(this.variantsCurrent, columnIndex, {
                id: nextId,
                price: nextVariant ? nextVariant.price : null,
                featured_image: nextVariant && nextVariant.featured_image ? nextVariant.featured_image.src : null,
                available: nextVariant ? nextVariant.available : null,
              });
              if (nextId != null) this.handleVariantChange(newColumnValue, nextId, columnIndex);
            },
            handleVariantChange(columnValue, variantId, columnIndex) {
              const variants = (this.variantsMap && this.variantsMap[columnValue]) || [];
              const selected = variants.find((variant) => variant && String(variant.id) === String(variantId)) || null;
              const price = selected ? selected.price : null;
              const featuredImage = selected && selected.featured_image ? selected.featured_image.src : null;
              const available = selected ? selected.available : null;

              if (typeof columnIndex === 'number') {
                const previous = (this.variantsCurrent && this.variantsCurrent[columnIndex]) || {};
                this.$set(this.variantsCurrent, columnIndex, {
                  ...previous,
                  id: variantId,
                  price,
                  featured_image: featuredImage,
                  available,
                });
              }
            },
            getVariantOptionValue(columnValue, item) {
              const position = (this.variantPositionMap && this.variantPositionMap[columnValue]) || 1;
              const key = 'option' + String(position);
              return (item && item[key]) || (item && item.public_title) || '';
            },
            getVariantLabel(columnValue, item) {
              const value = this.getVariantOptionValue(columnValue, item);
              return value || (item && item.public_title) || '';
            },
            getColorSwatchStyle(columnValue, item) {
              const value = this.getVariantOptionValue(columnValue, item);
              const key = String(value || '')
                .toLowerCase()
                .trim();
              const map = (this.colorSwatchMap && this.colorSwatchMap[columnValue]) || {};
              return map[key] || '';
            },
            buildMapFromOptions(getValueFn) {
              const map = {};
              (this.options || []).forEach((option) => {
                if (!option || option.value == null) return;
                const value = getValueFn(option);
                if (value != null) {
                  map[option.value] = value;
                }
              });
              return map;
            },
            normalizeComparableValue(value) {
              if (value == null) return '';
              return String(value).trim();
            },
            getVisibleColumnIndices() {
              const maxCount = this.isCondensedLayout ? 2 : Math.min(this.values.length, this.productColumns);
              return this.values
                .slice(0, maxCount)
                .map((_, index) => index)
                .filter((index) => this.values[index]);
            },
            shouldHideComparableValues(values) {
              if (!this.hideDuplicates || values.length < 2) return false;
              const firstValue = values[0];
              return values.every((value) => value === firstValue);
            },
            getPrimaryRowComparableValue(columnIndex, rowIndex) {
              const handle = this.values[columnIndex];
              if (!handle) return '';
              const imageValue = ((this.specificationImageMap[handle] || [])[rowIndex]) || '';
              const textValue = ((this.specificationListMap[handle] || [])[rowIndex]) || '';
              return [
                this.normalizeComparableValue(imageValue),
                this.normalizeComparableValue(textValue),
              ].join('||');
            },
            shouldHidePrimaryRow(rowIndex) {
              const rowValues = this.getVisibleColumnIndices().map((columnIndex) =>
                this.getPrimaryRowComparableValue(columnIndex, rowIndex),
              );
              return this.shouldHideComparableValues(rowValues);
            },
            getGroupSpecificationMap(groupIndex) {
              const groupMaps = {
                1: this.specificationListGroup1Map,
                2: this.specificationListGroup2Map,
                3: this.specificationListGroup3Map,
                4: this.specificationListGroup4Map,
                5: this.specificationListGroup5Map,
              };
              return groupMaps[groupIndex] || {};
            },
            getGroupRowDisplayValue(groupIndex, columnIndex, rowIndex) {
              const handle = this.values[columnIndex];
              if (!handle) return '';
              const groupMap = this.getGroupSpecificationMap(groupIndex);
              const rawValue = ((groupMap[handle] || [])[rowIndex]);
              if (rawValue === '.') return '.';
              if (rawValue == null || rawValue === '') return '-';
              return this.normalizeComparableValue(rawValue);
            },
            shouldHideGroupRow(groupIndex, rowIndex) {
              const rowValues = this.getVisibleColumnIndices().map((columnIndex) =>
                this.getGroupRowDisplayValue(groupIndex, columnIndex, rowIndex),
              );
              return this.shouldHideComparableValues(rowValues);
            },
            isGroupFullyHidden(groupIndex, rowCount) {
              if (!this.hideDuplicates) return false;
              const totalRows = Number(rowCount) || 0;
              if (totalRows === 0) return true;

              for (let rowIndex = 0; rowIndex < totalRows; rowIndex += 1) {
                if (!this.shouldHideGroupRow(groupIndex, rowIndex)) {
                  return false;
                }
              }

              return true;
            },
            hasVisiblePrimaryRows() {
              const totalRows = Number(this.primaryRowCount) || 0;
              for (let rowIndex = 0; rowIndex < totalRows; rowIndex += 1) {
                if (!this.shouldHidePrimaryRow(rowIndex)) {
                  return true;
                }
              }

              return false;
            },
            hasVisibleGroupedRows() {
              const groupRowCounts = this.groupRowCounts || {};
              return Object.keys(groupRowCounts).some((groupIndex) => {
                return !this.isGroupFullyHidden(Number(groupIndex), groupRowCounts[groupIndex]);
              });
            },
            handleSpecificationVisibilityChange() {
              this.$nextTick(() => {
                _this.refreshDynamicHeights();
              });
            },
          },
          computed: {
            imageMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.product_image);
            },
            productTitleMap() {
              return this.buildMapFromOptions((option) => option.label);
            },
            variantsMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.variants);
            },
            variantPositionMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.variant_position);
            },
            colorSwatchMap() {
              return this.buildMapFromOptions((option) => {
                const rows =
                  option && option.data && Array.isArray(option.data.color_swatch_config)
                    ? option.data.color_swatch_config
                    : [];
                const map = {};
                rows.forEach((row) => {
                  if (!row || row.label == null) return;
                  const key = String(row.label).toLowerCase().trim();
                  const value = row.value;
                  if (key && value) map[key] = value;
                });
                return map;
              });
            },
            specificationImageMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_image);
            },
            specificationListMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list);
            },
            minPriceMap() {
              return this.buildMapFromOptions((option) => option.min_price);
            },
            productUrlMap() {
              return this.buildMapFromOptions((option) => option.product_url);
            },
            specificationListGroup1Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_1);
            },
            specificationListGroup2Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_2);
            },
            specificationListGroup3Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_3);
            },
            specificationListGroup4Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_4);
            },
            specificationListGroup5Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_5);
            },
            hasVisibleComparisonData() {
              return this.hasVisiblePrimaryRows() || this.hasVisibleGroupedRows();
            },
          },
        });
      }
      handleClick(event) {
        const addButton = event.target && event.target.closest ? event.target.closest('.yg-product-button-add-to-cart') : null;
        if (!addButton || !this.contains(addButton)) return;

        event.preventDefault?.();
        this.handleAddToCart(addButton);
      }
      handleResize() {
        this.syncResponsiveState();
        this.refreshDynamicHeights();
        if (this.isFloatingTopBarEnabled) {
          this.requestFloatingNavStateUpdate();
        }
      }
      handleWindowScroll() {
        if (!this.isFloatingTopBarEnabled) return;
        this.requestFloatingNavStateUpdate();
      }
      handleTopBarScroll() {
        const targetKeys = this.isFloatingTopBarEnabled
          ? ['floating-top-bar-scroll', 'product-top-scroll', 'product-data-scroll']
          : ['product-top-scroll', 'product-data-scroll'];
        this.syncScroll('product-top-bar-scroll', targetKeys);
      }
      handleFloatingTopBarScroll() {
        if (!this.isFloatingTopBarEnabled) return;
        this.syncScroll('floating-top-bar-scroll', ['product-top-bar-scroll', 'product-top-scroll', 'product-data-scroll']);
      }
      handleTopScroll() {
        const targetKeys = this.isFloatingTopBarEnabled
          ? ['product-top-bar-scroll', 'floating-top-bar-scroll', 'product-data-scroll']
          : ['product-top-bar-scroll', 'product-data-scroll'];
        this.syncScroll('product-top-scroll', targetKeys);
      }
      handleDataScroll() {
        const targetKeys = this.isFloatingTopBarEnabled
          ? ['product-top-bar-scroll', 'floating-top-bar-scroll', 'product-top-scroll']
          : ['product-top-bar-scroll', 'product-top-scroll'];
        this.syncScroll('product-data-scroll', targetKeys);
      }
      syncScroll(sourceKey, targetKeys) {
        const source = this.sectionsEl[sourceKey];
        const nextTargetKeys = Array.isArray(targetKeys) ? targetKeys : [targetKeys];

        if (!source || this._syncingScroll) return;

        this._syncingScroll = true;
        nextTargetKeys.forEach((targetKey) => {
          const target = this.sectionsEl[targetKey];
          if (!target || target === source) return;
          if (target.scrollLeft === source.scrollLeft) return;
          target.scrollLeft = source.scrollLeft;
        });
        requestAnimationFrame(() => {
          this._syncingScroll = false;
        });
      }
      syncResponsiveState() {
        if (!this._vue) return;

        const isCondensedLayout = window.matchMedia('(max-width: 1150px)').matches;
        this._vue.isCondensedLayout = isCondensedLayout;
      }
      closeTopBarDropdowns() {
        this.querySelectorAll('.yg-product-select').forEach((selectEl) => {
          const instance = selectEl.__vue__;
          if (!instance) return;

          if (typeof instance.blur === 'function') {
            instance.blur();
          }

          if ('visible' in instance) {
            instance.visible = false;
          }
        });

        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        document.querySelectorAll(`.yg-product-compare-top-popper-${sectionId}`).forEach((popper) => {
          popper.style.display = 'none';
          popper.setAttribute('aria-hidden', 'true');
        });
      }
      getFloatingNavTopOffset() {
        const styles = getComputedStyle(this);
        const headerHeightValue = parseFloat(styles.getPropertyValue('--header-height'));
        const headerVisibleValue = parseFloat(styles.getPropertyValue('--header-is-visible'));
        const headerHeight = Number.isFinite(headerHeightValue) ? headerHeightValue : 0;
        const headerVisible = Number.isFinite(headerVisibleValue) ? headerVisibleValue : 1;
        return Math.max(0, (headerHeight - 1.5) * headerVisible);
      }
      requestFloatingNavStateUpdate() {
        if (!this.isFloatingTopBarEnabled) return;
        if (this._floatingNavFrame) return;

        this._floatingNavFrame = requestAnimationFrame(() => {
          this._floatingNavFrame = null;
          this.updateFloatingNavState();
        });
      }
      updateFloatingNavState() {
        if (!this.isFloatingTopBarEnabled) return;
        const floatingShell = this.sectionsEl['floating-top-bar-shell'];
        const sourceShell = this.sectionsEl['product-top-bar-shell'];
        const sourceScroll = this.sectionsEl['product-top-bar-scroll'];
        if (!floatingShell || !sourceShell || !sourceScroll) return;

        const stickyTop = this.getFloatingNavTopOffset();
        const sectionRect = this.getBoundingClientRect();
        const sourceShellRect = sourceShell.getBoundingClientRect();
        const sourceScrollRect = sourceScroll.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

        const isSectionVisible = sectionRect.top < viewportHeight && sectionRect.bottom > stickyTop;
        const hasSourceBarScrolledOut = sourceShellRect.bottom <= stickyTop;
        const shouldShowFloating = isSectionVisible && hasSourceBarScrolledOut;
        const wasFloatingActive = floatingShell.classList.contains('is-active');

        this.style.setProperty('--floating-nav-top', `${stickyTop}px`);
        this.style.setProperty('--floating-nav-left', `${sourceScrollRect.left}px`);
        this.style.setProperty('--floating-nav-width', `${sourceScrollRect.width}px`);

        if (wasFloatingActive !== shouldShowFloating) {
          this.closeTopBarDropdowns();
        }

        floatingShell.classList.toggle('is-active', shouldShowFloating);
        floatingShell.setAttribute('aria-hidden', shouldShowFloating ? 'false' : 'true');
      }
      refreshDynamicHeights() {
        requestAnimationFrame(() => {
          this.syncDropdownHeights();
          const productData = this.sectionsEl['product-data'];
          if (productData && productData.hasAttribute('open')) {
            productData.style.height = 'auto';
          }
          if (this.isFloatingTopBarEnabled) {
            this.requestFloatingNavStateUpdate();
          }
        });
      }
      syncDropdownHeights() {
        this.querySelectorAll('yg-dropdown').forEach((dropdown) => {
          dropdown.setContentContainerHeight?.();
        });
      }
      handleAddToCart(item) {
        const variantId = item?.dataset?.variantId || item?.getAttribute?.('data-variant-id');

        if (!variantId && !item.classList.contains('disabled')) return;

        const form = this.sectionsEl['product-form'];
        const idInput = this.sectionsEl['product-form-id'];
        if (!form || !idInput) return;

        idInput.value = String(variantId);
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        idInput.dispatchEvent(new Event('input', { bubbles: true }));

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
          return;
        }

        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn && typeof submitBtn.click === 'function') {
          submitBtn.click();
          return;
        }

        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }
    if (!window.customElements.get('yg-product-compare-v3')) {
      window.customElements.define('yg-product-compare-v3', YGProductCompareV3);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", ()=>{
    class YGVideoList01 extends HTMLElement {
        constructor() {
            super();
            this.playbackMode = this.getAttribute('data-playback-mode');
            this.slideItems = this.querySelectorAll('.yg-slide-item');
            this.handleClickPlayback = this.handleClickPlayback.bind(this);
        }
        connectedCallback() {
            if (this.playbackMode === 'click') {
                this.addEventListener('click', this.handleClickPlayback, true);
            }

            if (this.playbackMode === 'hover' && window.innerWidth > 1024) {
                this.initHoverPlayback();
            }
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.handleClickPlayback, true);
        }

        handleClickPlayback(event) {
            const target = event.target instanceof Element ? event.target : null;
            const playButton = target ? target.closest('.yg-play') : null;
            if (!playButton || !this.contains(playButton)) return;

            const currentVideo = playButton.closest('yg-video');
            if (!currentVideo || !this.contains(currentVideo)) return;

            this.pauseOtherVideos(currentVideo);
        }

        pauseOtherVideos(currentVideo) {
            this.querySelectorAll('yg-video').forEach((videoEl) => {
                if (videoEl === currentVideo || typeof videoEl.pauseVideo !== 'function') return;
                videoEl.pauseVideo();
            });
        }

        initHoverPlayback() {
            this.slideItems.forEach(item => {
                const videoEl = item.querySelector('yg-video');
                if (!videoEl) return;

                item.addEventListener('mouseenter', () => {
                    if (videoEl.playVideo) {
                        videoEl.playVideo();
                    }
                });

                item.addEventListener('mouseleave', () => {
                    if (videoEl.pauseVideo) {
                        videoEl.pauseVideo();
                    }
                });
            });
        }
    }
    if (!window.customElements.get('yg-video-list-01')) {
        window.customElements.define('yg-video-list-01', YGVideoList01);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
